import AppGraphQl from "js/graphql/resolvers/types.resolver";
import { GQLParamBuilder } from "../../../../helpers";
import { useState } from "react";
import { useEffect } from "react";
import { ModelMapResult, OperationMapResult } from "../helpers";

const getQueryPromise = (client, op, vars) => {
  const opBuilder = new GQLParamBuilder(client);

  opBuilder.setOperation(op);

  const variables = { ...vars };

  opBuilder.setVariables({ ...variables });

  return opBuilder.exec();
};

const fetchTypes = async (client, models, ops, idPrograma) => {
  try {
    const { getInputTypes } = AppGraphQl.queries;

    const queries = models.map(model => {
      return getQueryPromise(client, getInputTypes, {
        typeName: model.modelName
      });
    });

    const operations = ops.map(op => {
      return getQueryPromise(client, op.query, { idPrograma });
    });

    const modelResults = await Promise.all(queries);
    let opsResults = await Promise.all(operations);

    let opsKeys = ops.map(op => op.key);
    opsResults = opsResults.map(op => op.data);

    const modelMapResult = new ModelMapResult();
    const opsMapResult = new OperationMapResult();

    const modelsMap = modelMapResult.map(modelResults);
    const opsMap = opsMapResult.map({ keys: opsKeys, results: opsResults });

    return { model: modelsMap, ops: opsMap };
  } catch (error) {
    console.log(error.message);
  }
};

export const useGetTypes = ({ client, models, ops, idPrograma }) => {
  const [fields, setFields] = useState(null);

  useEffect(
    () => {
      const getFields = async () => {
        if (models.length === 0) return;

        const modelFields = await fetchTypes(client, models, ops, idPrograma);

        if (modelFields) setFields(modelFields);
      };

      getFields();
    },
    [models, ops]
  );

  return fields;
};
